import React, { useEffect, useState } from "react";
import DesktopHeader from "../../DesktopCommonComponents/DesktopHeader/DesktopHeader";
import { useHistory } from "react-router";
import BreadcrumbUI from "../../DesktopCommonComponents/Breadcrumb/BreadcrumbUI";
import GetInTouch from "../../GetInTouch/GetInTouch";
import GetInTouchDesktop from "../../GetInTouch/GetInTouchDesktop";
import StickyFooter from "../../StickyFooter/StickyFooter";
import DesktopFooter from "../../DesktopCommonComponents/DesktopFooter/DesktopFooter";
import { isMobile } from "../../helperFunc";
import style from "./style.module.css";
import HeadLines from "../../CommonComponents/HeadLines";
import NewsCard from "./NewsCard";

import Loader from "../../CommonComponents/Loader/Loader";
import { HomePageServices } from "../../../../../_services/Arya2.0/HomePageServices";
const NewsAndUpdate = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getNewsData = async () => {
    // let response = await CMSService.getPageDetailOfCMSby(2);
    const response = await HomePageServices.getPageDetailOfCMSby(
      2,
      "",
      null,
      true
    );
    setIsLoading(false);
    if (response && response?.data) {
      setData(response?.data);
    }
  };
  useEffect(() => {
    setIsLoading(true);
    getNewsData();
  }, []);
  const breadCrumbItems = [
    { text: "Home", url: "/" },
    { text: "Media Coverage", url: "" },
  ];
  return (
    <>
      <Loader isLoading={isLoading} />

      {!isMobile && <DesktopHeader />}
      <div>
        {!isMobile && (
          <BreadcrumbUI
            onBackArrowClick={() => history.goBack()}
            items={breadCrumbItems}
          />
        )}
        <div className={!isMobile && "padding-left-right100 margin-top40"}>
          <>
            <HeadLines
              className={`font-weight500 font-size24 letterSpacing001 ${style["line-height29"]} colorDark5`}
              text="Media Coverage"
            />
            <HeadLines
              className={`margin-top4 font-weight400 font-size20 letterSpacing001 line-height23 colorDark7`}
              text="Find out about arya.ag and its achievements in the agritech industry over the news."
            />
          </>
          <div className={style["margin-top36"]}>
            <NewsCard cardData={data} />
          </div>
        </div>
        {isMobile ? <GetInTouch /> : <GetInTouchDesktop />}
        {isMobile ? <StickyFooter /> : <DesktopFooter />}
      </div>
    </>
  );
};
export default NewsAndUpdate;
